export const calcPriceIncludingTax = (price: number, taxRate: number): number => {
  // 税率をパーセントから小数に変換（100で割る）
  const taxRateDecimal = taxRate / 100;

  // 税額を計算（金額(税込) x 税率 の小数点以下を切り捨て）
  const taxAmount = Math.floor(price * taxRateDecimal);

  // 金額(税込) = 金額(税抜き) + 税額
  const priceIncludingTax = price + taxAmount;

  return priceIncludingTax;
};
export const calculateTaxExcludedPrice = (priceIncludingTax: number, taxRate: number): number => {
  const taxExcludedPrice = priceIncludingTax / (1 + taxRate);
  return Math.floor(taxExcludedPrice);
};
